export default {
  "Reset Password": { tw: "重設密碼", cn: "重设密码" },
  "Delete School": { tw: "刪除學校", cn: "删除学校" },
  Hello: { tw: "哈囉", cn: "哈罗" },
  Recommendations: { tw: "推薦使用", cn: "推荐使用" },
  Announcements: { tw: "公告" },
  Announcement: { tw: "公告" },
  Title: { tw: "標題", cn: "标题" },
  Date: { tw: "日期" },
  "Frequently Visited": { tw: "經常瀏覽", cn: "经常浏览" },
  Close: { tw: "關閉", cn: "关闭" },
  "Recently Viewed": { tw: "近期瀏覽", cn: "近期浏览" },
  Content: { tw: "內容", cn: "内容" },
  Detail: { tw: "詳細內容", cn: "详细内容" },
  Progress: { tw: "進度", cn: "进度" },
  Username: { tw: "使用者名稱", cn: "使用者名称" },
  "Account activated on": { tw: "帳號啟用於", cn: "帐号激活於" },
  "Date of Birth": { tw: "生日" },
  Email: { tw: "電子郵件", cn: "电子邮件" },
  "Last Updated": { tw: "最後更新日期", cn: "最后更新日期" },
  WeChat: { tw: "微信" },
  unfilled: { tw: "未填寫", cn: "未填写" },
  Language: { tw: "語言", cn: "语言" },
  Password: { tw: "密碼", cn: "密码" },
  "New password": { tw: "新密碼", cn: "新密码" },
  "Confirm new password": { tw: "確認新密碼", cn: "确认新密码" },
  Submit: { tw: "提交", cn: "提交" },
  Cancel: { tw: "取消" },
  "Deactivate Account": { tw: "停用本帳號", cn: "停用本帐号" },
  "Checking password": { tw: "密碼確認中", cn: "密码确认中" },
  Modify: { tw: "修改中" },
  Required: { tw: "必填" },
  "Invalid email format": { tw: "無效電子郵件格式", cn: "无效电子邮件格式" },
  "Passwords are not the same": { tw: "新密碼不一致", cn: "新密码不一致" },
  "Changing password": { tw: "密碼更換中", cn: "密码更換中" },
  Schools: { tw: "學校", cn: "学校" },
  School: { tw: "學校", cn: "学校" },
  Classroom: { tw: "教室" },
  "Teaching Assistant": { tw: "教學小助教", cn: "教学小助教" },
  Downloads: { tw: "資源下載", cn: "资源下载" },
  "Teaching Video": { tw: "師訓影片", cn: "师训视频" },
  Phone: { tw: "電話", cn: "电话" },
  Location: { tw: "地點", cn: "地点" },
  "Contract Start": { tw: "合約生效", cn: "合同生效" },
  "Contract End": { tw: "合約中止", cn: "合同中止" },
  Teachers: { tw: "教師群", cn: "教师群" },
  Name: { tw: "名稱", cn: "名称" },
  "Signed in": { tw: "登入" },
  Status: { tw: "狀態", cn: "状态" },
  "Sign-up Code": { tw: "註冊碼", cn: "注册码" },
  "Access Levels": { tw: "權限等級", cn: "权限等级" },
  Groups: { tw: "群組", cn: "群组" },
  "Online Monitor": { tw: "在線人數", cn: "在线人数" },
  Code: { tw: "註冊碼", cn: "注册码" },
  "Send Code": { tw: "發送註冊碼", cn: "发送注册码" },
  Send: { tw: "發送", cn: "发送" },
  To: { tw: "至" },
  "Groups & Access": { tw: "群組&權限", cn: "群组&权限" },
  Tags: { tw: "標籤", cn: "标签" },
  "Group the accouts with tags. Add new tag in new line.": {
    tw: "於新的一行新增標籤以建立新的群組",
    cn: "於新的一行新增标签以建立新的群组"
  },
  "Content Access": { tw: "權限內容", cn: "权限内容" },
  "What can the teacher access? Select all that applies.": {
    tw: "選取老師可以瀏覽的內容",
    cn: "选取老师可以浏览的内容"
  },
  "What can the school access?": {
    tw: "選取學校可以瀏覽的內容:",
    cn: "选取老师可以浏览的内容:"
  },
  "Select all that applies:": { tw: " " },
  "Not assigned": { tw: "尚未註冊", cn: "尚未注册" },
  Never: { tw: "從未登入", cn: "从未登入" },
  Expired: { tw: "過期", cn: "过期" },
  "Will expire today": { tw: "將於今日過期", cn: "将於今日过期" },
  "Will expire in ": { tw: "將於 ", cn: "将於 " },
  " days": { tw: " 天後過期", cn: " 天後过期" },
  Modification: { tw: "修改" },
  "Confirm Password": { tw: "密碼確認", cn: "密码确认" },
  EXIT: { tw: "離開", cn: "离开" },
  "Teaching Notes": { tw: "教學筆記", cn: "教学笔记" },
  "Add School": { tw: "新增學校", cn: "新增学校" },
  "The contract has expired,please check school's information": {
    tw: "學校合約已過期，請確認學校資訊",
    cn: "合同已过期，请检查学校资讯"
  },
  "Book Resources": { tw: "課本資源", cn: "课本资源" },
  Others: { tw: "其它" },
  "Lesson Plans": { tw: "課堂計畫", cn: "课堂计画" },
  "Teaching Videos": { tw: "教學影片", cn: "教学影片" },
  Print: { tw: "列印" },
  "Other Resources": { tw: "其它資源", cn: "其它资源" },
  Country: { tw: "地點", cn: "地点" },
  Province: { tw: "省" },
  City: { tw: "城市" },
  District: { tw: "區", cn: "区" },
  Address: { tw: "地址" },
  Book: { tw: "書名", cn: "书名" },
  Distance: { tw: "距離", cn: "距离" },
  Reset: { tw: "重設", cn: "重设" },
  Search: { tw: "搜尋", cn: "搜寻" },
  Searching: { tw: "搜尋中", cn: "搜寻中" },
  "All Books": { tw: "所有書名", cn: "所有书名" },
  Total: { tw: "總數", cn: "总数" },
  schools: { tw: "學校", cn: "学校" },
  "Ok! No school nearby.": {
    tw: "附近無其它學校使用此本書籍!",
    cn: "附近无其它学校使用此本书籍!"
  },
  "Warning! Other schools nearby.": {
    tw: "警告! 附近有學校使用此本書籍",
    cn: "警告! 附近有学校使用此本书籍"
  },
  "School Info": { tw: "學校資料", cn: "学校资料" },
  Principal: { tw: "校長", cn: "校长" },
  "Member Since": { tw: "加入日期" },
  "Contract Duration": { tw: "合約期限", cn: "合同期限" },
  to: { tw: "至" },
  Admin: { tw: "管理者" },
  Editor: { tw: "編撰者", cn: "编撰者" },
  Saler: { tw: "業務", cn: "业务" },
  Exit: { tw: "離開", cn: "离开" },
  "Zoom In": { tw: "放大" },
  Users: { tw: "使用者" },
  "Filter all the users by": { tw: "篩選所有使用者", cn: "筛选所有使用者" },
  "User type": { tw: "使用者類型", cn: "使用者类型" },
  "Search for user": { tw: "搜尋使用者", cn: "搜寻使用者" },
  "Reactivate all selected": { tw: "重啟所選帳號", cn: "重启所选帐号" },
  "Deactivate all selected": { tw: "停用所選帳號", cn: "停用所选帐号" },
  "Delete all selected": { tw: "刪除所選帳號", cn: "删除所选帐号" },
  "Change email": { tw: "更改電子郵件", cn: "更改电子邮件" },
  "Create a new admin、editor、saler account": {
    tw: "新增管理者、編撰者、業務帳號",
    cn: "新增管理者、编撰者、业务帐号"
  },
  "Generate Login Code": { tw: "產生註冊碼", cn: "产生注册码" },
  "Admin Login Code": { tw: "管理者註冊碼", cn: "管理者注册码" },
  "Editor Login Code": { tw: "編撰者註冊碼", cn: "编撰者注册码" },
  "Saler Login Code": { tw: "業務註冊碼", cn: "业务注册码" },
  Mobile: { tw: "手機簡訊", cn: "手机简讯" },
  "Please add a tag for classification of editors": {
    tw: "請新增標籤以對編輯者進行分類",
    cn: "请添加标签以对编辑者进行分类"
  },
  Note: { tw: "備註", cn: "备注" },
  "Users must be": { tw: "使用者狀態必須是", cn: "使用者状态必须是" },
  Deactivated: { tw: "停用" },
  or: { tw: "或" },
  Active: { tw: "使用中" },
  "Never activated": { tw: "從未啟動", cn: "从未激活" },
  "before they can be deleted.": { tw: "才能刪除", cn: "才能删除" },
  Parent: { tw: "父層", cn: "父层" },
  "User Type": { tw: "使用者類型", cn: "使用者类型" },
  "Account activated": { tw: "帳號啟用日期", cn: "帐号激活日期" },
  "Last signed in": { tw: "最近登入時間", cn: "最近登入时间" },
  "Login Code": { tw: "註冊碼", cn: "注册码" },
  "Change Admin": { tw: "更換管理者", cn: "更换管理者" },
  "Change Password": { tw: "更換密碼", cn: "更换密码" },
  "Move from": { tw: "從", cn: "从" },
  "Move to": { tw: "移至" },
  Move: { tw: "移動", cn: "移动" },
  "Please select a user!": { tw: "請勾選使用者!", cn: "请勾选使用者!" },
  "The account has been active": { tw: "帳號已啟動", cn: "帐号已激活" },
  "please select again": { tw: "請重新勾選", cn: "请重新勾选" },
  "The account has been deactivated": { tw: "帳號已停用", cn: "帐号已停用" },
  "The account hasn't been signed up": {
    tw: "帳號尚未註冊",
    cn: "帐号尚未注册"
  },
  "The account hasn't deactivated, please deactivate it first!": {
    tw: "請先停用帳號",
    cn: "请先停用帐号"
  },
  "Please change Principal": { tw: "請更換校長", cn: "请更换校长" },
  "to another admin before you delete Admin": {
    tw: "至另一個管理者,在刪除此管理者前",
    cn: "至另一个管理者,在删除此管理者前"
  },
  "Changing Admin": { tw: "管理者更換中", cn: "管理者更换中" },
  "Are you sure you want to change this principal from": {
    tw: "確定更換此校長從",
    cn: "确定更换此校长从"
  },
  Warning: { tw: "警告" },
  "Are you sure you want to delete the account(s)": {
    tw: "確定要刪除此帳號",
    cn: "确定要删除此帐号"
  },
  "This action cannot be undone.": {
    tw: "此動作將無法復原",
    cn: "此动作将无法复原"
  },
  "The users’ information will be deleted forever.": {
    tw: "使用者資料會永遠刪除",
    cn: "使用者资料会永远删除"
  },
  "Yes, I'm sure. Delete.": { tw: "是的,確定刪除", cn: "是的,确定删除" },
  Confirm: { tw: "確定", cn: "确定" },
  "Please enter a name": { tw: "請輸入名稱", cn: "请输入名称" },
  "Are you sure you want to create": { tw: "確定新增", cn: "确定新增" },
  admin: { tw: "管理者" },
  editor: { tw: "編撰者", cn: "编辑者" },
  saler: { tw: "業務", cn: "业务" },
  "Creating admin": { tw: "新增管理者中" },
  "Creating editor": { tw: "新增編撰者中", cn: "新增编辑者中" },
  "Creating saler": { tw: "新增業務中", cn: "新增业务中" },
  Reactivating: { tw: "重新啟動中", cn: "重新激活中" },
  Deactivating: { tw: "停用中" },
  Deleting: { tw: "正在刪除", cn: "正在删除" },
  "Other admins have deactivated": { tw: "其他管理者已停用" },
  "please activate one first": {
    tw: "請先啟動任一管理者",
    cn: "请先激活任一管理者"
  },
  "Please generate Admin Login Code first or select one never activated admin、editor、saler to resend email":
    {
      tw: "請先產生註冊碼或選擇尚未啟動的管理者、編撰者、業務以發送電子郵件",
      cn: "请先产生注册码或选择尚未激活的管理者、编撰者、业务以发送电子邮件"
    },
  "Please select one account to change email": {
    tw: "請選擇一帳號改變電子郵件",
    cn: "请选择一个帐户更改电子邮件"
  },
  "Email Login Code": { tw: "發送註冊碼", cn: "发送注册码" },
  "Please send the login code to the email below": {
    tw: "請發送註冊碼至下方電子郵件",
    cn: "请发送注册码至下方电子邮件"
  },
  "Please enter the email address": {
    tw: "請輸入電子郵件地址",
    cn: "请输入电子邮件地址"
  },
  Sending: { tw: "發送中", cn: "发送中" },
  "Please wait": { tw: "請稍後", cn: "请稍後" },
  "The login code has been sent to the email you specified.": {
    tw: "註冊碼已發送至您剛填入的郵件位址,",
    cn: "注册码已发送至您刚填入的邮件位址,"
  },
  "Thank you.": { tw: "感謝您!", cn: "感谢您!" },
  "Loading Accounts": { tw: "帳號資料讀取中", cn: "帐号资料读取中" },
  Accounts: { tw: "帳號", cn: "帐号" },
  "Principal Code": { tw: "校長註冊碼" },
  "Principal Username": { tw: "校長使用者名稱", cn: "校长使用者名称" },
  "Principal Status": { tw: "校長狀態", cn: "校长状态" },
  "Number of teacher’s account to add": {
    tw: "老師帳號新增數量",
    cn: "老师帐号新增数量"
  },
  "Add Teacher's Account": { tw: "新增老師帳號", cn: "新增老师帐号" },
  "Teacher's Login Code": { tw: "老師註冊碼", cn: "老师注册码" },
  "Account Status": { tw: "帳號狀態", cn: "帐号状态" },
  "Teacher Groups": { tw: "群組", cn: "群组" },
  Caution: { tw: "注意" },
  "The Customer will see the same thing": {
    tw: "客戶會看到此處輸入的內容",
    cn: "客户会看到此处输入的内容"
  },
  "Edit School": { tw: "修改學校", cn: "修改" },
  "School Name": { tw: "學校名稱", cn: "学校名称" },
  "The Customer will see what you've entered here": {
    tw: "客戶會看到此處輸入的內容",
    cn: "客户会看到此处输入的内容"
  },
  Next: { tw: "下一步" },
  Prev: { tw: "上一步" },
  "Contract Start Date": { tw: "合約生效日期", cn: "合同生效日期" },
  "Contract End Date": { tw: "合約結束日期", cn: "合同结束日期" },
  "Contract end date must come after contract start date!": {
    tw: "合約結束日期必須在生效日期之後",
    cn: "合同结束日期必须在生效日期之後"
  },
  "Updating school": { tw: "更新學校中", cn: "更新学校中..." },
  "Adding Teacher Accounts": { tw: "新增老師帳號中", cn: "新增老师帐号中" },
  "Deleting School": { tw: "刪除學校中", cn: "删除学校中" },
  "Are you sure you want to delete this school": {
    tw: "確定要刪除此間學校",
    cn: "确定要删除此间学校"
  },
  "All data will be erased forever.": {
    tw: ",資料會永遠消失",
    cn: ",资料会永远消失"
  },
  "If you are sure, please type the school name": {
    tw: "如已確認,請輸入此間學校名稱",
    cn: "如已确认,请输入此间学校名称"
  },
  "Title Name": { tw: "標題名稱", cn: "标题名称" },
  Hide: { tw: "隱藏", cn: "隐藏" },
  Timer: { tw: "計時器", cn: "计时器" },
  "White Logo": { tw: "白色Logo", cn: "白底Logo" },
  "Colored Logo": { tw: "彩色Logo" },
  Save: { tw: "儲存", cn: "储存" },
  "Are you sure you want to delete this": {
    tw: "確定要刪除此",
    cn: "确定要删除此"
  },
  title: { tw: "標題", cn: "标题" },
  "If you are sure, please type the title name": {
    tw: "如已確認,請輸入此標題名稱",
    cn: "如已确认,请输入此标题名称"
  },
  "Are you sure you want to delete this title": {
    tw: "確定要刪除此標題",
    cn: "确定要删除此标题"
  },
  "This title cannot be deleted because it is not empty.": {
    tw: "無法刪除尚未清空的標題",
    cn: "无法删除尚未清空的标题"
  },
  bookset: { tw: "套書", cn: "套书" },
  "If you are sure, please type the bookset name": {
    tw: "如已確認,請輸入套書名稱",
    cn: "如已确认,请输入套书名称"
  },
  unit: { tw: "單元", cn: "单元" },
  "If you are sure, please type the unit name": {
    tw: "如已確認,請輸入單元名稱",
    cn: "如已确认,请输入单元名称"
  },
  "This unit cannot be deleted because it is not empty.": {
    tw: "無法刪除尚未清空的單元",
    cn: "无法删除尚未清空的单元"
  },
  "Are you sure you want to delete this unit": {
    tw: "確定要刪除此單元",
    cn: "确定要删除此单元"
  },
  "Section Name": { tw: "標題名稱", cn: "标题名称" },
  section: { tw: "小節" },
  "If you are sure, please type the section name": {
    tw: "如已確認,請輸入小節名稱",
    cn: "如已确认,请输入小节名称"
  },
  "Are you sure you want to delete this section": {
    tw: "確定要刪除此小節",
    cn: "确定要删除此小节"
  },
  "This section cannot be deleted because it is not empty.": {
    tw: "無法刪除尚未清空的小節",
    cn: "无法删除尚未清空的小节"
  },
  Import: { tw: "匯入", cn: "汇入" },
  Edit: { tw: "編輯", cn: "编辑" },
  "Delete All Selected": { tw: "刪除所選", cn: "删除所选" },
  "Restore All Selected": { tw: "復原所選", cn: "复原所选" },
  Style: { tw: "樣式", cn: "样式" },
  "Last Modified": { tw: "上次修改日期" },
  Author: { tw: "作者" },
  "Are you sure you want to delete the page": {
    tw: "確定要刪除此頁面",
    cn: "确定要删除此页面"
  },
  "This action is unrecoverable.": {
    tw: "此動作將無法復原",
    cn: "此动作将无法复原"
  },
  "Are you sure you want to delete all selected pages": {
    tw: "確定要刪除所選頁面",
    cn: "确定要删除所选页面"
  },
  Toolbar: { tw: "工具列" },
  "You have not saved the page.": { tw: "此頁尚未儲存", cn: "此页尚未储存" },
  "You will lose all the modifications which haven't been saved.": {
    tw: "您將會失去尚未儲存的修改",
    cn: "您将会失去尚未储存的修改"
  },
  "Add Video Lists": { tw: "新增影片清單", cn: "新增视频清单" },
  "NEW VIDEO": { tw: "新影片", cn: "新视频" },
  "Are you sure you want to delete the video list": {
    tw: "確定要刪除此影片清單",
    cn: "确定要删除此视频清单"
  },
  "This act is unrecoverable.": {
    tw: "此動作將無法復原",
    cn: "此动作将无法复原"
  },
  "Are you sure you want to delete the folder": {
    tw: "確定要刪除此資料夾",
    cn: "确定要删除此资料夹"
  },
  "Are you sure you want to delete the video": {
    tw: "確定要刪除此影片",
    cn: "确定要删除此视频"
  },
  Rating: { tw: "評分", cn: "评分" },
  Comment: { tw: "評論", cn: "评论" },
  "Resolved?": { tw: "已修正?" },
  UpdateDate: { tw: "更新時間", cn: "更新时间" },
  "Student Assistant": { tw: "學生小助教", cn: "学生小助教" },
  "Reading Style Settings (Super Admin Only)": {
    tw: "閱讀樣式設定（僅限超級管理員）",
    cn: "阅读样式设定（仅限超级管理员）"
  },
  "Configure auto-help behavior for Reading Style 10 (student recording with assistance)":
    {
      tw: "設定閱讀樣式10的自動協助行為（學生錄音並提供協助）",
      cn: "设定阅读样式10的自动协助行为（学生录音并提供协助）"
    },
  "Silence Duration": { tw: "靜音持續時間", cn: "静音持续时间" },
  "Time in milliseconds before auto-help triggers when student is silent during recording.":
    {
      tw: "學生在錄音期間保持靜音多久後觸發自動協助（毫秒）",
      cn: "学生在录音期间保持静音多久后触发自动协助（毫秒）"
    },
  "Range:": { tw: "範圍：", cn: "范围：" },
  "Default:": { tw: "預設值：", cn: "默认值：" },
  "Help Cooldown": { tw: "協助冷卻時間", cn: "协助冷却时间" },
  "Cooldown period in milliseconds before auto-help can trigger again at the same position.":
    {
      tw: "在同一位置再次觸發自動協助之前的冷卻時間（毫秒）",
      cn: "在同一位置再次触发自动协助之前的冷却时间（毫秒）"
    },
  seconds: { tw: "秒" },
  "Reset to Defaults": { tw: "重設為預設值", cn: "重置为默认值" },
  "Save Settings": { tw: "儲存設定", cn: "保存设定" },
  "Note:": { tw: "注意：" },
  "These settings control the automatic help system in Reading Style 10:": {
    tw: "這些設定控制閱讀樣式10的自動協助系統：",
    cn: "这些设定控制阅读样式10的自动协助系统："
  },
  "When a student pauses during recording, the system waits this long before offering help":
    {
      tw: "當學生在錄音期間暫停時，系統會等待這段時間後才提供協助",
      cn: "当学生在录音期间暂停时，系统会等待这段时间后才提供协助"
    },
  "Prevents repeated help at the same reading position, giving students time to practice":
    {
      tw: "防止在同一閱讀位置重複提供協助，給學生練習的時間",
      cn: "防止在同一阅读位置重复提供协助，给学生练习的时间"
    },
  "Students need to refresh their page for changes to take effect.": {
    tw: "學生需要重新整理頁面才能使變更生效。",
    cn: "学生需要刷新页面才能使变更生效。"
  },
  "Super Admin Controls": { tw: "超級管理員控制", cn: "超级管理员控制" },
  "Reading settings saved successfully!": {
    tw: "閱讀設定儲存成功！",
    cn: "阅读设定保存成功！"
  },
  "Failed to save settings:": { tw: "儲存設定失敗：", cn: "保存设定失败：" },
  "Reading settings reset to defaults": {
    tw: "閱讀設定已重設為預設值",
    cn: "阅读设定已重置为默认值"
  },
  "Silence Duration must be between 1000ms (1 second) and 60000ms (60 seconds)":
    {
      tw: "靜音持續時間必須介於1000毫秒（1秒）到60000毫秒（60秒）之間",
      cn: "静音持续时间必须介于1000毫秒（1秒）到60000毫秒（60秒）之间"
    },
  "Help Cooldown must be between 5000ms (5 seconds) and 120000ms (120 seconds)":
    {
      tw: "協助冷卻時間必須介於5000毫秒（5秒）到120000毫秒（120秒）之間",
      cn: "协助冷却时间必须介于5000毫秒（5秒）到120000毫秒（120秒）之间"
    },
  // TestResults
  "Loading...": { tw: "載入中...", cn: "加载中..." },
  Correct: { tw: "正確", cn: "正确" },
  Incorrect: { tw: "錯誤", cn: "错误" },
  "Redo Wrong Test": { tw: "重做錯題", cn: "重做错题" },
  "Back to Wrong Words": { tw: "返回錯誤單字", cn: "返回错误单词" },
  "Back to Units": { tw: "返回單元", cn: "返回单元" },
  "Back to Books": { tw: "返回書本", cn: "返回书本" },
  Congratulations: { tw: "恭喜", cn: "恭喜" },
  "You've unlocked Level": { tw: "你已解鎖等級", cn: "你已解锁等级" },
  Question: { tw: "題目", cn: "题目" },
  // StatsSelect
  "Load More": { tw: "載入更多", cn: "加载更多" },
  "Select...": { tw: "選擇...", cn: "选择..." },
  // StatsTable
  Unknown: { tw: "未知", cn: "未知" },
  "Unknown Book": { tw: "未知書本", cn: "未知书本" },
  "Unknown Unit": { tw: "未知單元", cn: "未知单元" },
  Section: { tw: "小節", cn: "小节" },
  // AutoRefreshButton
  "Auto-Refresh ON": { tw: "自動刷新 開", cn: "自动刷新 开" },
  "Auto-Refresh OFF": { tw: "自動刷新 關", cn: "自动刷新 关" },
  "Auto-refresh every": { tw: "自動刷新間隔", cn: "自动刷新间隔" },
  seconds: { tw: "秒" },
  // StatsHelpers
  "No question type": { tw: "無題型", cn: "无题型" },
  "Recording question": { tw: "錄音題", cn: "录音题" },
  Unanswered: { tw: "未作答", cn: "未作答" },
  // StatsTable
  "Copy Link": { tw: "複製連結", cn: "复制链接" },
  // TestMode
  "Review Questions": { tw: "複習題目", cn: "复习题目" },
  "Loading page data...": { tw: "載入頁面資料中...", cn: "加载页面数据中..." },
  "Page data not loaded": { tw: "頁面資料未載入", cn: "页面数据未加载" },
  "No Question Available": { tw: "沒有可用的題目", cn: "没有可用的题目" },
  "There was an error loading the test question.": {
    tw: "載入測驗題目時發生錯誤。",
    cn: "加载测验题目时发生错误。"
  },
  "Loading question data...": { tw: "載入題目資料中...", cn: "加载题目数据中..." },
  "Unsupported Question Type": { tw: "不支援的題型", cn: "不支持的题型" },
  "is not supported in test mode.": {
    tw: "在測驗模式中不支援。",
    cn: "在测验模式中不支持。"
  },
  "Loading test questions...": { tw: "載入測驗題目中...", cn: "加载测验题目中..." },
  "No Questions Available": { tw: "沒有可用的題目", cn: "没有可用的题目" },
  "There are no word questions available for this test.": {
    tw: "此測驗沒有可用的單字題目。",
    cn: "此测验没有可用的单词题目。"
  },
  Leave: { tw: "離開", cn: "离开" },
  Finish: { tw: "完成", cn: "完成" },
  Next: { tw: "下一題", cn: "下一题" },
  of: { tw: "之", cn: "之" },
  "Word style": { tw: "單字樣式", cn: "单词样式" },
  // QuestionDialog
  "Loading question...": { tw: "載入題目中...", cn: "加载题目中..." },
  "Loading question content...": { tw: "載入題目內容中...", cn: "加载题目内容中..." },
  "Template not available for": { tw: "無法使用此範本：", cn: "无法使用此模板：" },
  style: { tw: "樣式", cn: "样式" },
  // WrongQuestionsAnalysis
  "Filter School": { tw: "篩選學校", cn: "筛选学校" },
  "Filter Classroom": { tw: "篩選班級", cn: "筛选班级" },
  "Filter Bookset": { tw: "篩選套書", cn: "筛选套书" },
  "Filter BookType": { tw: "篩選書類", cn: "筛选书类" },
  All: { tw: "全部", cn: "全部" },
  // WordStyle1 & WordStyle11
  "This activity is not ready yet. Please contact your teacher.": {
    tw: "此活動尚未準備好，請聯繫您的老師。",
    cn: "此活动尚未准备好，请联系您的老师。"
  },
  "Missing Content: Please add the correct answer text in the page editor.": {
    tw: "缺少內容：請在頁面編輯器中新增正確答案文字。",
    cn: "缺少内容：请在页面编辑器中添加正确答案文字。"
  },
  "Correct!": { tw: "正確！", cn: "正确！" },
  "Correct answer:": { tw: "正確答案：", cn: "正确答案：" },
  // BookTypes
  "Take Test": { tw: "開始測驗", cn: "开始测验" },
  "Take Exam": { tw: "開始正式考題", cn: "开始正式考题" },
  "Exam": { tw: "正式考題", cn: "正式考题" },
  "Start Review": { tw: "開始複習", cn: "开始复习" },
  Locked: { tw: "已鎖定", cn: "已锁定" },
  "Complete Level": { tw: "完成等級", cn: "完成等级" },
  "with 100% to unlock": { tw: "達到100%即可解鎖", cn: "达到100%即可解锁" },
  // ReadingStyle10
  "Please speak louder! Your microphone volume is too low.": {
    tw: "請說大聲一點！您的麥克風音量太低。",
    cn: "请说大声一点！您的麦克风音量太低。"
  },
  // Pages.js (Word Practice)
  "No Word Pages Found": { tw: "找不到單字頁面", cn: "找不到单词页面" },
  "There are no Word pages in this section yet.": {
    tw: "此區段尚無單字頁面。",
    cn: "此区段尚无单词页面。"
  },
  "Word Style": { tw: "單字樣式", cn: "单词样式" },
  "This Word style template is not yet implemented.": {
    tw: "此單字樣式範本尚未實作。",
    cn: "此单词样式模板尚未实现。"
  },
  "Word Practice Results": { tw: "單字練習結果", cn: "单词练习结果" },
  "Student Name:": { tw: "學生姓名：", cn: "学生姓名：" },
  "Level:": { tw: "等級：", cn: "等级：" },
  Level: { tw: "等級", cn: "等级" },
  Total: { tw: "總數", cn: "总数" },
  Redo: { tw: "重做", cn: "重做" },
  "No Word Pages": { tw: "無單字頁面", cn: "无单词页面" },
  "Go Back": { tw: "返回", cn: "返回" },
  Previous: { tw: "上一題", cn: "上一题" },
  // ComparisonDisplay.js
  "Correct Answer:": { tw: "正確答案：", cn: "正确答案：" },
  "Recording incomplete!": { tw: "錄音不完整！", cn: "录音不完整！" },
  "We only recognized part of your reading. Please speak louder and closer to the microphone, then try recording again.":
    {
      tw: "我們只辨識出部分錄音內容。請說大聲一點並靠近麥克風，然後再次錄音。",
      cn: "我们只识别出部分录音内容。请说大声一点并靠近麦克风，然后再次录音。"
    },
  // WordAndReadingSettings.js
  "Word Settings": { tw: "單字設定", cn: "单词设定" },
  "Configure word test behavior, adaptive learning system, and practice settings": { tw: "設定單字測驗行為、自適應學習系統及練習設定", cn: "设定单词测验行为、自适应学习系统及练习设定" },
  "Questions Per Test": { tw: "每次測驗題數", cn: "每次测验题数" },
  "Number of questions to include in each Word test. Students will take tests with this many questions.": { tw: "每次單字測驗包含的題目數量。學生將進行這麼多題目的測驗。", cn: "每次单词测验包含的题目数量。学生将进行这么多题目的测验。" },
  questions: { tw: "題", cn: "题" },
  "questions per test": { tw: "題/每次測驗", cn: "题/每次测验" },
  "Unlock Threshold Percentage": { tw: "解鎖門檻百分比", cn: "解锁门槛百分比" },
  "Percentage of correct answers required to unlock the next level. Students must score this percentage or higher to unlock the next book level.": { tw: "解鎖下一等級所需的正確答案百分比。學生必須達到此百分比或更高才能解鎖下一本書等級。", cn: "解锁下一等级所需的正确答案百分比。学生必须达到此百分比或更高才能解锁下一本书等级。" },
  "correct answers required to unlock next level": { tw: "正確答案才能解鎖下一等級", cn: "正确答案才能解锁下一等级" },
  "Mastery Threshold": { tw: "精熟門檻", cn: "精熟门槛" },
  "Number of consecutive correct answers required to mark an item as mastered and auto-move from wrong to correct list.": { tw: "將項目標記為已精熟並自動從錯誤列表移至正確列表所需的連續正確答案次數。", cn: "将项目标记为已精熟并自动从错误列表移至正确列表所需的连续正确答案次数。" },
  times: { tw: "次", cn: "次" },
  "Student needs to answer correctly": { tw: "學生需要正確回答", cn: "学生需要正确回答" },
  "times to master an item": { tw: "次才能精熟一個項目", cn: "次才能精熟一个项目" },
  "Auto-Move to Correct List": { tw: "自動移至正確列表", cn: "自动移至正确列表" },
  "Automatically move words from wrong list to correct list when mastery threshold is reached.": { tw: "當達到精熟門檻時，自動將單字從錯誤列表移至正確列表。", cn: "当达到精熟门槛时，自动将单词从错误列表移至正确列表。" },
  Enabled: { tw: "啟用", cn: "启用" },
  Disabled: { tw: "停用", cn: "停用" },
  "Words will auto-move when mastered": { tw: "精熟後單字將自動移動", cn: "精熟后单词将自动移动" },
  "Manual review required": { tw: "需要手動審核", cn: "需要手动审核" },
  "Reading Settings": { tw: "閱讀設定", cn: "阅读设定" },
  "Time in milliseconds before auto-help triggers when student is silent during recording.": { tw: "學生在錄音期間保持靜音多久後觸發自動協助（毫秒）。", cn: "学生在录音期间保持静音多久后触发自动协助（毫秒）。" },
  "Cooldown period in milliseconds before auto-help can trigger again at the same position.": { tw: "在同一位置再次觸發自動協助之前的冷卻時間（毫秒）。", cn: "在同一位置再次触发自动协助之前的冷却时间（毫秒）。" },
  "Database Cleanup Settings": { tw: "資料庫清理設定", cn: "数据库清理设定" },
  "Configure automatic cleanup of old test results to manage database size. Personal bests and level unlocks are always protected.": { tw: "設定自動清理舊測驗結果以管理資料庫大小。個人最佳紀錄和等級解鎖始終受保護。", cn: "设定自动清理旧测验结果以管理数据库大小。个人最佳纪录和等级解锁始终受保护。" },
  "Keep Recent Tests": { tw: "保留近期測驗", cn: "保留近期测验" },
  "Number of recent regular test results to keep per student per book. Older tests (beyond retention period) will be deleted.": { tw: "每位學生每本書保留的近期正式測驗結果數量。超過保留期限的舊測驗將被刪除。", cn: "每位学生每本书保留的近期正式测验结果数量。超过保留期限的旧测验将被删除。" },
  tests: { tw: "次測驗", cn: "次测验" },
  "recent tests per student per book": { tw: "近期測驗/每位學生/每本書", cn: "近期测验/每位学生/每本书" },
  "Keep Recent Practice Tests": { tw: "保留近期練習測驗", cn: "保留近期练习测验" },
  "Number of recent practice test results to keep per student per book. Practice tests are cleaned up more aggressively.": { tw: "每位學生每本書保留的近期練習測驗結果數量。練習測驗會更積極地清理。", cn: "每位学生每本书保留的近期练习测验结果数量。练习测验会更积极地清理。" },
  "recent practice tests per student per book": { tw: "近期練習測驗/每位學生/每本書", cn: "近期练习测验/每位学生/每本书" },
  "Retention Period (Days)": { tw: "保留期限（天）", cn: "保留期限（天）" },
  "Test results older than this many days will be deleted (except personal bests, level unlocks, and recent tests as configured above).": { tw: "超過此天數的測驗結果將被刪除（個人最佳紀錄、等級解鎖及上述設定的近期測驗除外）。", cn: "超过此天数的测验结果将被删除（个人最佳纪录、等级解锁及上述设定的近期测验除外）。" },
  days: { tw: "天", cn: "天" },
  "days retention": { tw: "天保留期", cn: "天保留期" },
  "Student Stats Settings": { tw: "學生統計設定", cn: "学生统计设定" },
  "Configure auto-refresh behavior for the student stats page displayed to teachers, admins, and principals": { tw: "設定顯示給教師、管理員和校長的學生統計頁面自動刷新行為", cn: "设定显示给教师、管理员和校长的学生统计页面自动刷新行为" },
  "Auto-Refresh Interval": { tw: "自動刷新間隔", cn: "自动刷新间隔" },
  "Time interval in milliseconds for automatic data refresh on the student stats page when enabled by teachers/admins.": { tw: "當教師/管理員啟用時，學生統計頁面自動刷新資料的時間間隔（毫秒）。", cn: "当教师/管理员启用时，学生统计页面自动刷新数据的时间间隔（毫秒）。" },
  "seconds refresh interval": { tw: "秒刷新間隔", cn: "秒刷新间隔" },
  "Database Maintenance": { tw: "資料庫維護", cn: "数据库维护" },
  "Tools for maintaining database integrity. Use with caution.": { tw: "維護資料庫完整性的工具。請謹慎使用。", cn: "维护数据库完整性的工具。请谨慎使用。" },
  "Clean Up Duplicate Wrong Words": { tw: "清理重複的錯誤單字", cn: "清理重复的错误单词" },
  "When admins edit question answers, students may end up with duplicate wrong answer records for the same question. This tool merges duplicates and preserves student progress (timesWrong + timesCorrect).": { tw: "當管理員編輯問題答案時，學生可能會有同一問題的重複錯誤答案記錄。此工具會合併重複項並保留學生進度（錯誤次數 + 正確次數）。", cn: "当管理员编辑问题答案时，学生可能会有同一问题的重复错误答案记录。此工具会合并重复项并保留学生进度（错误次数 + 正确次数）。" },
  "Warning:": { tw: "警告：", cn: "警告：" },
  "This operation cannot be undone. It will merge all duplicate records for all students.": { tw: "此操作無法復原。它將合併所有學生的所有重複記錄。", cn: "此操作无法复原。它将合并所有学生的所有重复记录。" },
  "Cleaning up...": { tw: "清理中...", cn: "清理中..." },
  "Clean Up Duplicates": { tw: "清理重複項", cn: "清理重复项" },
  "Saving...": { tw: "儲存中...", cn: "保存中..." },
  "Loading settings...": { tw: "載入設定中...", cn: "加载设定中..." },
  "Failed to load settings:": { tw: "載入設定失敗：", cn: "加载设定失败：" },
  "Settings saved successfully!": { tw: "設定儲存成功！", cn: "设定保存成功！" },
  "Failed to save settings:": { tw: "儲存設定失敗：", cn: "保存设定失败：" },
  "Settings reset to defaults (not saved)": { tw: "設定已重設為預設值（尚未儲存）", cn: "设定已重置为默认值（尚未保存）" },
  "Mastery Threshold must be between 1 and 10": { tw: "精熟門檻必須介於 1 到 10 之間", cn: "精熟门槛必须介于 1 到 10 之间" },
  "Questions Per Test must be between 1 and 100": { tw: "每次測驗題數必須介於 1 到 100 之間", cn: "每次测验题数必须介于 1 到 100 之间" },
  "Unlock Threshold Percentage must be between 1 and 100": { tw: "解鎖門檻百分比必須介於 1 到 100 之間", cn: "解锁门槛百分比必须介于 1 到 100 之间" },
  "Keep Recent Tests must be between 1 and 50": { tw: "保留近期測驗必須介於 1 到 50 之間", cn: "保留近期测验必须介于 1 到 50 之间" },
  "Keep Recent Practice must be between 1 and 50": { tw: "保留近期練習必須介於 1 到 50 之間", cn: "保留近期练习必须介于 1 到 50 之间" },
  "Retention Days must be between 30 and 365": { tw: "保留天數必須介於 30 到 365 之間", cn: "保留天数必须介于 30 到 365 之间" },
  "Auto-Refresh Interval must be between 1000ms (1 second) and 60000ms (60 seconds)": { tw: "自動刷新間隔必須介於 1000 毫秒（1 秒）到 60000 毫秒（60 秒）之間", cn: "自动刷新间隔必须介于 1000 毫秒（1 秒）到 60000 毫秒（60 秒）之间" },
  "Cleanup failed:": { tw: "清理失敗：", cn: "清理失败：" },
  "Cleanup failed": { tw: "清理失敗", cn: "清理失败" },
  "Word & Reading Style Settings (Super Admin Only)": { tw: "單字與閱讀樣式設定（僅限超級管理員）", cn: "单词与阅读样式设定（仅限超级管理员）" },
  "Word & Reading Style Settings": { tw: "單字與閱讀樣式設定", cn: "单词与阅读样式设定" },
  // SpeakingStyle0 & SpeakingStyle1
  "Pronunciation Assessment Results": { tw: "發音評量結果", cn: "发音评量结果" },
  Accuracy: { tw: "準確度", cn: "准确度" },
  Complete: { tw: "完整度", cn: "完整度" },
  Completeness: { tw: "完整度", cn: "完整度" },
  Speaking: { tw: "口說", cn: "口语" },
  "Model Answer": { tw: "範例答案", cn: "范例答案" },
  "Now it's your turn to repeat!": { tw: "換你重複說！", cn: "轮到你重复说！" },
  "Read the passage silently to prepare...": { tw: "請默讀段落，準備開口...", cn: "请默读段落，准备开口..." },
  "Read the passage aloud when ready.": { tw: "準備好了就大聲朗讀段落。", cn: "准备好了就大声朗读段落。" },
  "Ready when you are.": { tw: "準備好就開始。", cn: "准备好就开始。" },
  "Auto-stops in": { tw: "自動停止於", cn: "自动停止於" },
  "Recording... read the passage aloud.": { tw: "錄音中...請大聲朗讀段落。", cn: "录音中...请大声朗读段落。" },
  "Recording...": { tw: "錄音中...", cn: "录音中..." },
  "Speak now": { tw: "請開始朗讀", cn: "请开始朗读" },
  "Auto-stop": { tw: "自動停止", cn: "自动停止" },
  "Saved!": { tw: "已儲存！", cn: "已保存！" },
  "Preparation Time": { tw: "準備時間", cn: "准备时间" },
  // SpeakingStyle2
  "GEPT Elementary Assessment": { tw: "GEPT初級口說評量", cn: "GEPT初级口说评量" },
  Pronunciation: { tw: "發音", cn: "发音" },
  Fluency: { tw: "流暢度", cn: "流畅度" },
  Grammar: { tw: "文法", cn: "语法" },
  Vocabulary: { tw: "字彙", cn: "词汇" },
  "You said:": { tw: "你說：", cn: "你说：" },
  Good: { tw: "很好", cn: "很好" },
  Fair: { tw: "尚可", cn: "尚可" },
  Unclear: { tw: "不清楚", cn: "不清楚" },
  "Tip:": { tw: "提示：", cn: "提示：" },
  "Listen": { tw: "請聽", cn: "请听" },
  "Listen carefully... (1/2)": { tw: "仔細聆聽... (1/2)", cn: "仔细聆听... (1/2)" },
  "Get ready...": { tw: "準備好了嗎...", cn: "准备好了吗..." },
  "Listen again... (2/2)": { tw: "再聽一次... (2/2)", cn: "再听一次... (2/2)" },
  "Tap to start listening": { tw: "點擊開始聆聽", cn: "点击开始聆听" },
  "Press Play to listen, then Record your answer!": { tw: "按播放鍵聆聽，然後錄製你的回答！", cn: "按播放键聆听，然后录制你的回答！" },
  "Recording your answer...": { tw: "錄音中...", cn: "录音中..." },
  "Recording saved. Ready to submit?": { tw: "錄音已儲存，準備送出？", cn: "录音已保存，准备提交？" },
  "Analyzing your response...": { tw: "正在分析你的回答...", cn: "正在分析你的回答..." },
  "Response saved.": { tw: "回答已儲存。", cn: "回答已保存。" },
  Pause: { tw: "暫停", cn: "暂停" },
  Play: { tw: "播放", cn: "播放" },
  Model: { tw: "範例", cn: "范例" },
  "Try Again": { tw: "再試一次", cn: "再试一次" },
  Stop: { tw: "停止", cn: "停止" },
  "Re-record": { tw: "重新錄音", cn: "重新录音" },
  "Tap to Play": { tw: "點擊播放", cn: "点击播放" },
  Record: { tw: "錄音", cn: "录音" },
  "My Voice": { tw: "我的錄音", cn: "我的录音" },
  "Analyzing... please wait": { tw: "分析中，請稍候", cn: "分析中，请稍候" },
  "Microphone access denied. Please allow microphone access.": { tw: "麥克風存取被拒絕，請允許使用麥克風。", cn: "麦克风访问被拒绝，请允许使用麦克风。" },
  "Submission failed. Please try again.": { tw: "送出失敗，請再試一次。", cn: "提交失败，请再试一次。" },
  "Recording too short. Please speak for at least 1 second.": { tw: "錄音時間太短，請至少說話1秒鐘。", cn: "录音时间太短，请至少说话1秒钟。" },
  "No speech detected. Check your microphone and try again.": { tw: "未偵測到語音，請檢查麥克風後再試一次。", cn: "未检测到语音，请检查麦克风后再试一次。" },
  "No speech detected in your recording.": { tw: "您的錄音中未偵測到語音。", cn: "您的录音中未检测到语音。" }
};
